import { useMemo, useState } from 'react';
export function useAccountTransactionsFilter(initialFilters, resetFilters) {
    const [type, setType] = useState(initialFilters?.type);
    const [direction, setDirection] = useState(initialFilters?.direction);
    const [startAt, setStartAt] = useState(initialFilters?.startAt);
    const [endAt, setEndAt] = useState(initialFilters?.endAt);
    const disabledClearFilters = useMemo(() => {
        return (direction === resetFilters?.direction &&
            type === resetFilters?.type &&
            startAt === resetFilters?.startAt &&
            endAt === resetFilters?.endAt);
    }, [direction, type, startAt, endAt, resetFilters]);
    const disabledApplyFilters = useMemo(() => {
        return (direction === initialFilters?.direction &&
            type === initialFilters?.type &&
            startAt === initialFilters?.startAt &&
            endAt === initialFilters?.endAt);
    }, [direction, type, startAt, endAt, initialFilters]);
    return {
        type,
        setType,
        direction,
        setDirection,
        startAt,
        setStartAt,
        endAt,
        setEndAt,
        disabledClearFilters,
        disabledApplyFilters,
    };
}
